import Vue from 'vue'
import VueRouter from 'vue-router'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  }, {
    path: '/cadastro-movimentacao',
    name: 'Cadastro de movimentação',
    component: () => import('../views/Movimentacao.vue')
  },
  {
    path: '/gestao-contas',
    name: 'Gestão de Contas',
    component: () => import('../views/GestaoContas.vue')
  },

]

const router = new VueRouter({
  routes
})

export default router
